import { Bell } from 'lucide-react';
import { useNotifications } from '@/api/notifications';
import { Dropdown } from '@/components/ui/Dropdown';
import { NotificationsDropdown } from './NotificationsDropdown';
import { useFaviconBadge } from '@/hooks/useFaviconBadge';

export function NotificationsBell() {
  const { data } = useNotifications();
  const unread = (data ?? []).filter((n) => !n.is_read).length;
  useFaviconBadge(unread);

  return (
    <div data-tour="notification-bell">
    <Dropdown
      align="right"
      trigger={
        <button
          className="relative p-2 rounded-md text-white/60 hover:text-white hover:bg-white/10 transition-colors"
          aria-label={`Notifications${unread ? `, ${unread} unread` : ''}`}
        >
          <Bell size={18} />
          {unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
              {unread > 99 ? '99+' : unread}
            </span>
          )}
        </button>
      }
    >
      {(close) => <NotificationsDropdown onNavigate={close} />}
    </Dropdown>
    </div>
  );
}
